import React from 'react';
import styled from 'styled-components/macro';

interface Props {
    children: React.ReactNode;
    light?: boolean;
    className?: string;
    stopPropagation?: boolean;
}

const ScrollVerticalWithoutRef = (props: Props, ref: React.Ref<HTMLDivElement>): JSX.Element => {
    return (
        <S_ScrollVertical
            ref={ref}
            className={props.className}
            $light={props.light}
            onScroll={(e) => {
                if (props.stopPropagation) {
                    e.stopPropagation();
                }
            }}
        >
            {props.children}
        </S_ScrollVertical>
    );
};

export const ScrollVertical = React.forwardRef(ScrollVerticalWithoutRef);

const S_ScrollVertical = styled.div<{ $light: boolean }>`
    overflow-y: scroll;
    overflow-x: hidden;
    height: 100%;
    &::-webkit-scrollbar,
    &::-webkit-scrollbar {
        width: 15px;
    }
    &::-webkit-scrollbar-track {
        background-color: ${(props) => (props.$light ? '#dfdfdf' : '#242424')};
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${(props) => (props.$light ? '#bababa' : '#414141')};
        border-radius: 0px;
    }
`;
